// extracted by mini-css-extract-plugin
export default {"glamour":"vbCE82","vogue":"pMzehm","inStyle":"WN17qN","buzzFeed":"O2Nujk","gq":"lEizpp","esquire":"aVZ3SQ"};